import { CharField, SingleSelectField } from "@inmagik/magik-ui"
import { getIn, useFormikContext } from "formik"
import { Col } from "react-bootstrap"
import type { Genre } from "../../types"
import { RECORD_MEDIA_TYPES } from "../../constants"

export default function GenreForm({ col = 8 }: { col?: number }) {
  const { setFieldValue, values, errors, submitCount } = useFormikContext<Genre>()

  return (
    <Col xs={col} className="d-flex flex-column align-items-stretch gap-4">
      <CharField
        label="Nome"
        layout="horizontal"
        value={values.name}
        onChange={(value) => {
          setFieldValue("name", value)
        }}
        isValid={submitCount > 0 ? !getIn(errors, "name") : undefined}
        errorMessage={getIn(errors, "name")}
        required
      />

      <SingleSelectField
        label="Tipologia"
        layout="horizontal"
        options={RECORD_MEDIA_TYPES}
        value={RECORD_MEDIA_TYPES.find((type) => type.value === values.record_media_type) || null}
        onChange={(value) => {
          setFieldValue("record_media_type", value?.value || "")
        }}
        isValid={submitCount > 0 ? !getIn(errors, "record_media_type") : undefined}
        errorMessage={getIn(errors, "record_media_type")}
        required
      />
    </Col>
  )
}
